import React from "react";
import classNames from "classnames";

interface Props {
  pageIndex: number;
  isSelectedPage: boolean;
  handleSelectPage: (index: number) => void;
}

const PaginationItem: React.FC<Props> = (props: Props): JSX.Element => {
  const { pageIndex, isSelectedPage = false, handleSelectPage } = props;

  const itemClassList = classNames("caprx-pagination-item", `caprx-pagination-item-num-${pageIndex + 1}`, {
    "caprx-pagination-item-selected-page": isSelectedPage,
  });

  return (
    <li className={itemClassList}>
      <a className="caprx-pagination-link" onClick={(): void => handleSelectPage(pageIndex)} tabIndex={0}>
        {pageIndex + 1}
      </a>
    </li>
  );
};

export default PaginationItem;
